document.addEventListener("DOMContentLoaded", function() {
    gsap.registerPlugin(ScrollTrigger);

    gsap.utils.toArray(".categoria").forEach((section, index) => {
        gsap.to(section, {
            scrollTrigger: {
                trigger: section,
                start: "top 80%",
                end: "top 40%",
                scrub: true
            },
            opacity: 1,
            scale: 1,
            y: 0,
            duration: 1.5,
            ease: "power3.out",
            delay: index * 0.3
        });
    });
});
